<template>

  <div class="container">
    <form accept-charset="UTF-8" role="form" @submit.stop.prevent="handleSubmit">
      <h2>{{ title }}</h2>
      <p class="text-muted">{{ msg }}</p>
      <div class="alert alert-success" v-show="successMessage">
        {{ successMessage }}
      </div>
      <div class="alert alert-danger" v-show="errorMessage">
        {{ errorMessage }}
      </div>
      <fieldset>
        <div class="input-group mb-3">
          <span class="input-group-addon"><i class="icon-user"></i></span>
          <input class="form-control" placeholder="Customer ID" name="username" type="text" v-model="username"
                 required min="1" pattern="[0-9]+" :disabled="disableAllInputs"
                 oninvalid="setCustomValidity('Numeric Customer ID required (not your name or email). Spaces and non-numeric characters are not allowed')"
                 oninput="setCustomValidity('')">
        </div>
      <input class="btn btn-primary px-4" type="submit" value="Reset Password"
             :disabled="protectedUI || !formIsValid || disableAllInputs">
      </fieldset>
    </form>
  </div>

</template>

<script>
  import { BACKEND_SERVICE } from '../../http-common-service'

  export default {
    name: 'ForgotPassword',
    data: () => ({
      title: 'Forgot Password',
      msg: 'Please enter your customer ID. You will be emailed a link to reset your password.',
      errorMessage: null,
      successMessage: null,
      disableAllInputs: false,
      protectedUI: false,
      username: ''
    }),
    methods: {
      handleSubmit () {
        this.$raven.setUserContext({
          username: this.username
        })

        // Remove alert boxes
        this.successMessage = null
        this.errorMessage = null
        this.protectedUI = true

        this.$store.dispatch('forgotPassword', {
          username: this.username
        }).then(() => {
          this.disableAllInputs = true
          this.errorMessage = null
          this.successMessage = 'Forgot Password Email Sent'
          this.$router.push({ name: 'PasswordConfirmation', query: { u: this.username } })
        }).catch((err) => {
          if (err.message === 'User password cannot be reset in the current state.') {
            this.disableAllInputs = true

            BACKEND_SERVICE.put('scms/v1/tenants/' + this.$store.getters.tenant + '/users/' + this.username + '/reset')
              .then(() => {
                this.errorMessage = null
                this.successMessage = 'Please check your email for an invitation and follow those instructions.'
              })
              .catch(e => {
                this.errorMessage = 'There was an issue re-sending your invitation email.  Please wait a few minutes and try again.'
                this.$raven.captureException(e)
              })
          } else {
            this.errorMessage = err.message
            this.protectedUI = false
            this.$raven.captureException(err)
          }
        })
      },
      assignUser (user) {
        if (user === '' || user === undefined) {
          return false
        }
        this.username = user
        return true
      }
    },
    computed: {
      formIsValid () {
        return /[\S]+/.test(this.username)
      },
      authenticated () {
        return this.$store.getters.cognitoAuthenticated
      }
    },
    mounted: function () {
      // if query param 'u' provided, automatically add that to username
      // and submit form
      let username = this.$route.query.u
      if (this.assignUser(username)) {
        this.$router.replace({ name: 'ForgotPassword' })
        this.handleSubmit()
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/auth/ForgotPassword.vue?28906de4